class ReviewWall extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.rows = [...this.querySelectorAll('[data-review-wall-row]')];
    if (!this.rows.length) return;

    this.fillTries = 0;
    this.fillRows();
    this.resizeObserver = new ResizeObserver(() => this.fillRows());
    this.resizeObserver.observe(this);

    this.intersectionObserver = new IntersectionObserver(
      ([entry]) => {
        this.classList.toggle('is-paused', !entry.isIntersecting);
      },
      { threshold: 0.05 }
    );
    this.intersectionObserver.observe(this);
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    this.intersectionObserver?.disconnect();
  }

  fillRows() {
    const board = this.querySelector('.review-wall__board');
    if (!board) return;

    const styles = getComputedStyle(this);
    const perRow = Number.parseFloat(styles.getPropertyValue('--rw-per-row')) || 2;
    const gap = Number.parseFloat(styles.getPropertyValue('--rw-gap')) || 12;
    const inner = this.querySelector('.review-wall__inner');
    const boardWidth = board.offsetWidth || inner?.clientWidth || this.clientWidth;
    if (boardWidth <= 0) {
      this.fillTries = (this.fillTries || 0) + 1;
      if (this.fillTries < 8) requestAnimationFrame(() => this.fillRows());
      return;
    }
    this.fillTries = 0;

    const cardW = (boardWidth - (perRow - 1) * gap) / perRow;
    if (cardW > 0) board.style.setProperty('--rw-card-w', `${cardW}px`);

    this.rows.forEach((row) => {
      const track = row.querySelector('.review-wall__track');
      const group = row.querySelector('[data-review-wall-group]');
      if (!track || !group || !group.children.length) return;

      track.querySelectorAll('[data-review-wall-clone]').forEach((node) => node.remove());
      [...group.children].forEach((card) => {
        if (!card.hasAttribute('data-original')) card.remove();
      });

      const originals = [...group.querySelectorAll('[data-original]')];
      if (!originals.length) return;

      const target = Math.max(row.offsetWidth, boardWidth, 1);
      let guard = 0;
      while (group.offsetWidth < target && guard < 12) {
        originals.forEach((card) => {
          const copy = card.cloneNode(true);
          copy.removeAttribute('data-original');
          group.appendChild(copy);
        });
        guard += 1;
        if (originals[0].offsetWidth === 0) break;
      }

      const clone = group.cloneNode(true);
      clone.removeAttribute('data-review-wall-group');
      clone.setAttribute('data-review-wall-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });
  }
}

if (!customElements.get('review-wall')) {
  customElements.define('review-wall', ReviewWall);
}
